import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import { TextStyle } from '@tiptap/extension-text-style'

/**
 * Розширення пресета «letter» понад StarterKit: колір тексту й маркер (Q13.5).
 *
 * Одні й ті самі в редакторі (`RichTextInput`) і в показі (`RichTextView`):
 * схема показу без них мовчки знімала б колір і маркер із листа, і картка
 * показувала б не те, що пішло адресату.
 *
 * HTML: `<span style="color: …">`, `<mark style="background-color: …">` —
 * рівно те, що пропускає бек (`RichTextStyleAttributeSanitizer`).
 */
export const LETTER_EXTENSIONS = [TextStyle, Color, Highlight.configure({ multicolor: true })]
